import styled from 'styled-components';

export const Sections = styled.section`
  width: 400px;
  height: 270px;
  margin: 20px;
  padding: 0px;
  border: 1px solid #ddd;
  border-radius: 5px;
  align-content: center;
  text-align: center;
`;

export const Text = styled.h2`
  font-size: 24px;
  margin-bottom: 10px;
`;
